function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81C784",
  d: "M20.786 14.573l38.678-.176v25.745L39.66 58.73 20.787 39.826z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M20 14h1v22h-1zm39 0h1v16h-1zm-38 0h38v1H21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.586 23.935l-8.762 6.668M33.29 14.541l6.298-4.848 6.731 4.973m12.98 9.441l8.932 6.44M12.014 68.803V31.42l27.6 26.87L68.01 31.344v37.459z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.324 33.526a4.938 4.938 0 01-1.389-.958l-.107-.107.084-.127.582-.875a.785.785 0 01.264-.248.7.7 0 01.356-.098c.15 0 .302.051.457.148.129.081.276.176.44.285.159.105.34.21.544.316.144.074.309.135.496.181l.261-3.113c-.32-.096-.636-.205-.949-.328a3.785 3.785 0 01-1.007-.582 2.755 2.755 0 01-.735-.933c-.188-.38-.28-.846-.28-1.4a3.247 3.247 0 01.967-2.286c.313-.31.697-.566 1.152-.766.414-.182.88-.292 1.4-.331l.07-.817a.727.727 0 01.203-.445.652.652 0 01.493-.205h.897l-.133 1.559a4.28 4.28 0 011.296.456c.407.23.762.49 1.064.78l.111.105-.084.13-.463.709c-.082.12-.168.212-.258.277a.614.614 0 01-.367.112.833.833 0 01-.349-.091c-.107-.05-.229-.11-.366-.181a8.257 8.257 0 00-.44-.209 2.664 2.664 0 00-.307-.113l-.238 2.842c.324.103.645.215.963.336.376.142.716.328 1.019.555.31.233.56.522.752.868.195.352.291.787.291 1.303 0 .502-.083.975-.25 1.417a3.496 3.496 0 01-.732 1.178 3.7 3.7 0 01-1.18.828 4.531 4.531 0 01-1.432.366l-.08.985a.737.737 0 01-.2.438.646.646 0 01-.495.21h-.897l.14-1.685a5.894 5.894 0 01-1.564-.486zm4.163-1.917c.245-.262.368-.605.368-1.04 0-.17-.03-.315-.086-.436a1.046 1.046 0 00-.249-.333 1.704 1.704 0 00-.398-.266 4.094 4.094 0 00-.31-.136l-.222 2.67c.39-.083.688-.237.897-.46zm-2.246-7.151c-.18.077-.325.17-.436.277a.97.97 0 00-.236.348c-.05.131-.076.27-.076.418 0 .171.028.319.084.444.057.128.136.241.24.341.108.105.236.199.386.281.091.05.187.098.288.142l.198-2.384c-.17.033-.32.078-.448.133z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.929 40.481h23.764M30.072 43.72h19.527M34.57 46.958h10.827",
  stroke: "#371447"
}));

function SvgBillPaymentsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBillPaymentsLg;